import React, { useCallback, useEffect, useState } from "react";
import { Dropdown, Form, Modal } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { apiCall } from "../../../_services/apiCall";
import config from "../../../config/config.json";
import "../../Sector_Question_Manage/control.css";
import CreateSectorQuestionModal from "./CreateSectionModal";

export const Question = (props) => {
  const {
    frameworkData,
    allFrameworks,
    allIndustries,
    unitSettings,
  } = props;
  
  const [topics, setTopics] = useState([]);
  const [addTopic, setAddTopic] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState(true);

  const showAddTopicPopup = () => setAddTopic(true);
  const closeAddTopicPopup = () => {
    setAddTopic(false);
    setSelectedQuestion(null);
    setEditMode(false);
  };

  const filteredTopics = topics.filter((topic) => {
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch =
        topic.title?.toLowerCase().includes(searchLower) ||
        topic.questionType?.toLowerCase().includes(searchLower); // Changed to questionType to match tbody

      if (!matchesSearch) return false;
    }

    if (statusFilter === true) return topic.status === 1;
    if (statusFilter !== true) return topic.status === 0;

    return true;
  });

  const getReportingQuestion = useCallback(async () => {
    if (frameworkData?.id) {
      const { data } = await apiCall(
        `${config.ADMIN_API_URL}getReportingQuestion`,
        {},
        { module_ids: [frameworkData?.id] },
        "GET"
      );
      setTopics(data?.data?.reverse());
    }
  }, [frameworkData?.id]);

  const deleteQuestion = async (item) => {
    await apiCall(
      `${config.ADMIN_API_URL}deleteReportingQuestion`,
      {},
      { id: item?.questionId },
      "POST"
    );
    getReportingQuestion();
  };

  const handleEditQuestion = (item) => {
    setSelectedQuestion(item);
    setEditMode(true);
    showAddTopicPopup();
  }

  useEffect(() => {
    if (props.frameworkData.id) {
      getReportingQuestion();
    }
  }, [props.frameworkData.id, getReportingQuestion]);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <div className="heading">
          <h4 className="m-0">{frameworkData.title}</h4>
          <span className="global_link mx-0">
            <div
              onClick={showAddTopicPopup}
              className="mx-3 add_framework_control"
            >
              <i className="fas fa-plus-square fs-lg" title="Add Topic"></i>
              &nbsp;&nbsp;
            </div>
          </span>
        </div>
        <div className="d-flex align-items-center gap-3">
          <input
            type="search"
            className="form-control"
            style={{ width: 220 }}
            placeholder="Search Topics"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <Form.Check
            type="switch"
            id="status-toggle"
            label={statusFilter === true ? "Active" : "Inactive"}
            checked={statusFilter === true}
            onChange={() => setStatusFilter((prev) => !prev)}
          />
        </div>
      </div>
      
      <div className="table_f border-top mt-2 auto_scroll_by_design">
        <Table striped bordered className="mt-2 mb-0">
          <thead>
            <tr className="heading_color sticky_header">
              <th style={{ width: 50 }}>Sr.</th>
              <th>Question Title</th>
              <th>Question Type</th>
              <th style={{ width: 50 }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredTopics.length > 0 ? (
              filteredTopics.map((item, key) => (
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>{item.title}</td>
                  <td>{item.questionType}</td>
                  <td className="text-center">
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic"></Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handleEditQuestion(item)}>
                          <i className="fas fa-edit"></i>&nbsp;&nbsp; Edit Question
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => deleteQuestion(item)} disabled={item.isDerived}>
                          <i className="fas fa-trash"></i>&nbsp;&nbsp; Delete Question
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-muted py-4">
                  {searchTerm ? "No questions found matching your search" : "No questions available"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Modal show={addTopic} onHide={closeAddTopicPopup} size="lg">
        <Modal.Header style={{ borderBottom: "1.5px solid #eef1f5", padding: "16px 20px" }}>
          <Modal.Title style={{ fontWeight: 700, fontSize: "16px", color: "#0f172a", display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ width: 32, height: 32, borderRadius: 8, background: "#f0f6ff", display: "flex", alignItems: "center", justifyContent: "center", color: "#2b7fe0" }}>
              <i className={`fas ${editMode ? "fa-edit" : "fa-plus-circle"}`} style={{ fontSize: 14 }}></i>
            </span>
            {editMode ? "Edit Question" : "Add Question"}
          </Modal.Title>
          <button
            type="button"
            onClick={closeAddTopicPopup}
            style={{ background: "none", border: "1.5px solid #e2e8f0", borderRadius: "8px", width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#64748b", marginLeft: "auto", transition: "all 0.18s" }}
            onMouseEnter={e => { e.currentTarget.style.background = "#fff5f2"; e.currentTarget.style.borderColor = "#e05c3a"; e.currentTarget.style.color = "#e05c3a"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "none"; e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.color = "#64748b"; }}
            title="Close"
          >
            <i className="fas fa-times" style={{ fontSize: 13 }}></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <CreateSectorQuestionModal
              module={frameworkData}
              allFrameworks={allFrameworks}
              allIndustries={allIndustries}
              unitSettings={unitSettings} 
              existingQuestion={selectedQuestion}
              isDerived={selectedQuestion?.isDerived}
              onSuccess={() => {
                closeAddTopicPopup();
                getReportingQuestion();
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer style={{ height: 65 }}> </Modal.Footer>
      </Modal>
    </div>
  );
};